<template>
  <div>
    <a-input
      :placeholder="placeholder"
      id="keyword"
      style="width: 390px"
      v-model="keyword"
      allowClear
      @pressEnter="searchByKeyword"
      @change="keywordChange"
    />
    <ul v-if="showSearchList" class="select-wrapper">
      <li
        v-for="(item, index) in searchArr"
        :key="index"
        class="select-item"
        @click="selectAddress(index)"
      >
        {{ item.label }}
      </li>
    </ul>

    <a-button
      @click="searchByKeyword"
      style="margin-left: 10px"
      type="primary"
      :loading="searchLoading"
      >搜索</a-button
    >
    <div id="map_container" class="mapContent"></div>
  </div>
</template>
<script>
import coordtransform from "coordtransform";
export default {
  props: ["addrs", "maps", "createTime"],
  name: "coordinatePickQqMap",
  data() {
    return {
      searchArr: [],
      showSearchList: false,
      searchLoading: false,
      keyword: "",
      lnglat: "116.397644,39.907733",
      map: null,
      markers: null,
      zoom: 16,
      placeholder: "按关键字搜索",
      search: null,
      dragLat: "",
      dragLng: "",
    };
  },
  filters: {},
  mounted() {
    if (this.maps.length) {
      this.keyword = this.addrs.addrs;
      this.lnglat = this.addrs.lnglat;
    }
    this.$nextTick(() => {
      this.loadMap();
    });
  },
  methods: {
    // 点击清除x后关闭搜索结果列表
    keywordChange(evt) {
      if (evt.target.value == "") {
        this.showSearchList = false;
      }
    },
    // 添加标记
    setMarker(lat, lng) {
      this.map.panTo(new TMap.LatLng(lat, lng));
      this.markers.setMap(null); //每次点击地图时将地图的标记清空
      this.markers = null;
      this.markers = new TMap.MultiMarker({
        map: this.map,
        geometries: [],
        styles: {
          highlight: new TMap.MarkerStyle({
            src: "https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/marker-pink.png",
          }),
        },
      });
      this.markers.add([
        {
          id: String(0),
          position: new TMap.LatLng(
            Number(lat).toFixed(6),
            Number(lng).toFixed(6)
          ),
        },
      ]);
      this.showSearchList = false;

      // 初始化几何图形及编辑器
      const editor = new TMap.tools.GeometryEditor({
        map: this.map, // 编辑器绑定的地图对象
        overlayList: [
          {
            overlay: this.markers, // 可编辑图层
            id: "marker",
            selectedStyleId: "highlight", // 被选中的marker会变为高亮样式
          },
        ],
        actionMode: TMap.tools.constants.EDITOR_ACTION.INTERACT, // 编辑器的工作模式
        activeOverlayId: "marker", // 激活图层
        selectable: true,
      });

      // 监听修改完成事件，获取绘制几何图形
      editor.on("adjust_complete", (geometry) => {
        this.dragLat = Number(geometry.position.lat).toFixed(6);
        this.dragLng = Number(geometry.position.lng).toFixed(6);

        this.lnglat = this.dragLng + "," + this.dragLat;
        this.geocoder();
      });
    },
    async geocoder() {
      this.searchLoading = true;
      let result = await this.$http.post("/system/geocoder", {
        lat: this.dragLat,
        lng: this.dragLng,
      });
      if (result.data.status === 1) {
        this.searchLoading = false;
        this.keyword = result.data.data.formatted_addresses.recommend;
        this.$emit("change", {
          lnglat: this.lnglat,
          addrs: this.keyword,
        });
      } else {
        this.$message.warning(result.data.msg);
        this.searchLoading = false;
      }
    },
    selectAddress(index) {
      this.keyword = this.searchArr[index].label;
      this.lnglat = this.searchArr[index].lnglat;
      this.$emit("change", {
        lnglat: this.lnglat,
        addrs: this.keyword,
      });

      // 添加标记
      let slnglat = this.lnglat.split(",");
      this.setMarker(Number(slnglat[1]), Number(slnglat[0]));
    },
    // 初始化地图
    loadMap() {
      let slnglat = this.lnglat.split(",");
      this.map = null;
      this.center = new TMap.LatLng(Number(slnglat[1]), Number(slnglat[0]));
      this.map = new TMap.Map("map_container", {
        center: this.center,
        zoom: this.zoom,
        showControl: false,
      });
      this.search = new TMap.service.Search({ pageSize: 20 });
      this.markers = new TMap.MultiMarker({
        map: this.map,
        geometries: [],
      });
      // 添加标记
      this.setMarker(slnglat[1], slnglat[0]);
    },
    // 关键字搜索
    searchByKeyword() {
      let keyword = document.getElementById("keyword").value;
      if (!keyword) {
        this.placeholder = "请输入搜索关键字";
        return;
      }
      this.showSearchList = false;
      this.searchMap(keyword);
    },
    // 准备搜索结果
    searchMap(val, evt) {
      this.searchLoading = true;
      this.search
        .searchNearby({
          keyword: val,
          center: this.center,
          radius: 1000,
        })
        .then((result) => {
          let that = this;
          that.searchLoading = false;
          that.searchArr = [];
          if (result.data.length > 0) {
            result.data.forEach((item, index) => {
              that.searchArr.push({
                label: item.title,
                lnglat: item.location.lng + "," + item.location.lat,
              });

              that.showSearchList = that.searchArr ? true : false;
            });
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.select-wrapper {
  width: 100%;
  max-height: 300px;
  min-height: 30px;
  z-index: 9999;
  position: absolute;
  padding: 0;
  background: #fff;
  border-radius: 4px;
  overflow: auto;
  margin-top: 0px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: all 0.3s;

  .select-item {
    line-height: 15px;
    list-style: none;
    padding: 7px 10px;
    margin: 0;
    cursor: pointer;

    &:hover {
      background: #e6f7ff;
    }
  }
}
div[aria-hidden="true"] {
  display: none !important;
}

.mapContent {
  width: 100%;
  height: 350px;
  border: 1px #dbdbdb solid;
  border-radius: 3px;
}

.select_title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
#container {
  overflow: hidden;
  width: 100%;
  height: 100%;
  margin: 0;
  font-family: "微软雅黑";
}

.anchorBL {
  display: none;
}

#panel {
  position: absolute;
  background: #fff;
  width: 350px;
  padding: 20px;
  z-index: 9999;
  top: 30px;
  left: 30px;
}
</style>
